import React, { useEffect, useRef, useState } from "react"
import { Card, Col, PopoverBody, Row, UncontrolledPopover } from "reactstrap"
import UpdateTable from "../../../components/Common/UpdatedTable"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import action from "../../../assets/icons/action.svg"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import InventoryFilter from "../filter"
import {
  fetchBoosterSearch,
  updateBoosterStatus,
} from "../../../services/Settings/settings"
import { createSelector } from "reselect"
import { useSelector } from "react-redux"
import EditBooster from "./edit"
import { useLocation } from "react-router-dom"

const Booster = () => {
  const companyname = localStorage.getItem('companyname')
  document.title = `Booster${companyname ? ` | ${companyname}` : 'MEP -Hub'}`;

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const { loggedUser } = useSelector(LoginProperties)

  const locations = useLocation();
  const crumb = locations?.state?.menuLabel || ""

  const [page, setPage] = useState("")

  const [state, setState] = useState()
  const [count, setCount] = useState(0)
  const [search, setSearch] = useState("")
  const [status, setStatus] = useState("")
  const [editState, setEditState] = useState({ modal: false, value: "" })
  const [dataPerPage, setDataPerPage] = useState(25)
  const [isLoadingNextPage, setIsLoadingNextPage] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetchBoosterSearch({
        params: `${status == "0" || status == "1" ? `&status=${status}` : ""}${search ? `&searchText=${search}` : "&searchText"
          }${`&sortOrder=asc`}${page ? `&page=${page}` : ""}${dataPerPage ? `&sizePerPage=${dataPerPage}` : ""}`,
      })
      // setState(response)
      const newData = response?.data?.data || [];

      setState(prev =>
        page > 1 && prev
          ? {
            ...response,
            data: {
              ...response.data,
              data: [...(prev.data?.data || []), ...newData],
            },
          }
          : response
      );
      setIsLoadingNextPage(response == undefined ? true : false)
      isLoadingRef.current = false;
    }
    fetchData()
  }, [count, status, search, page, dataPerPage])

  const tableContainerRef = useRef(null)
  const isLoadingRef = useRef(false);
  const scrollTimeoutRef = useRef(null);

  useEffect(() => {
    const handleScroll = (e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
      
      scrollTimeoutRef.current = setTimeout(() => {
        if (
          scrollTop + clientHeight >= scrollHeight - 50 &&
          !isLoadingRef.current &&
          page < state?.data?.last_page
        ) {
          isLoadingRef.current = true;
          setIsLoadingNextPage(true);
          setPage(prev => prev + 1);
        }
      }, 200);
    };
    
    const container = tableContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }
    
    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, [state, page]);

  const handleEdit = item => {
    setEditState({ value: item, modal: true })
  }

  const handleStatus = async id => {
    try {
      const response = await updateBoosterStatus(id)
      toastSuccess(response?.message)
      setCount(count + 1)
    } catch (err) {
      toastError(err?.message)
    }
  }

  const handleSizePerPageChange = size => {
    setDataPerPage(size)
  }


  const columns = [
    {
      label: "Vaccine",
      renderCell: item => (
        <div className="capitalize-letter">{item?.vaccine?.name}</div>
      ),
    },
    {
      label: "Booster",
      renderCell: item => <div className="capitalize-letter">{item?.name}</div>,
      sortKey: "name",
    },
    {
      label: "Status",
      renderCell: item => (
        <div>
          <div
            className={`font-13 ${item?.status === 1 ? "status-active" : "status-inactive"
              }`}
          >
            {item?.status === 1 ? "Active" : "Inactive"}
          </div>
        </div>
      ),
    },
    {
      label: "Action",
      renderCell: item => (
        <>
          <div>
            <span id={`PopoverLegacy-${item?.id}`}>
              <img src={action} alt="" className="pointer" />
            </span>
          </div>
          <UncontrolledPopover
            placement="bottom"
            target={`PopoverLegacy-${item?.id}`}
            trigger="legacy"
          >
            <PopoverBody>
              {item?.status === 1 &&
                loggedUser?.permission?.some(
                  permissionItem => permissionItem?.name === "booster_edit"
                ) && (
                  <div
                    className="table-popup-content"
                    onClick={() => handleEdit(item)}
                  >
                    Edit
                  </div>
                )}
              <div
                className={`${item?.status === 1 ? "popover-border" : ""
                  } table-popup-content`}
                onClick={() => handleStatus(item?.id)}
              >
                {item?.status === 1 ? "Deactivate" : "Activate"}
              </div>
            </PopoverBody>
          </UncontrolledPopover>
        </>
      ),
    },
  ]

  const handlePaginate = page => {
    setPage(page)
  }

  const handleUpdate = () => {
    setCount(count + 1)
  }

  const handleResetValue = () => {
    setEditState("")
  }

  const handleStatusChange = id => {
    setStatus(id)
    setPage(1)
  }
  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            <Breadcrumbs
              title="Settings"
              breadcrumbObject={[
                { title: "Settings", link: "/settings" },
                { title: "Masters", link: "/settings" },
                { title: "Booster", link: "/settings-booster" },
              ]}
            />
            {loggedUser?.permission?.some(
              permissionItem => permissionItem?.name === "booster_create"
            ) && (
                <EditBooster
                  key={"x"}
                  onUpdate={handleUpdate}
                  onReset={handleResetValue}
                  buttonLabel="+&nbsp; Booster"
                  className="px-2 mb-3 me-2 btn btn-primary"
                  editItem={editState}
                />
              )}
          </div>
          <Card className="me-2 px-2 pb-2">
            <InventoryFilter
              handleStatusChange={handleStatusChange}
              handleSearchChange={handleSearchChange}
              sampleUrl={"download/state.xlsx"}
              importUrl={"state/import"}
              showExport={false}
            />
            <hr className="table-divide" />
            <Row className="mt-2 ever-rise-table">
              <Col xs={12}>
              <div ref={tableContainerRef} style={{ maxHeight: "490px", overflowY: "auto" }}>
                {state?.data?.data && (
                  <UpdateTable
                    className="mt-5"
                    nodes={state?.data?.data}
                    paginate={state?.data}
                    CurrentPage={page}
                    columns={columns}
                    handlePagination={handlePaginate}
                    handleSizePerPage={handleSizePerPageChange}
                    tableWidth="30% 30% 20% 20% 20%"
                    mobileWidth="30% 30% 20% 20% 20%"
                    isLoading={isLoadingNextPage}
                    hidePaginate={true}
                  />
                )}
                </div>
              </Col>
            </Row>
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Booster
